/* Sable & Sweep 1/2/3 Pack picker + compact cross-sell (G26).
   Packs: selecting a card only sets the product form's quantity (no cart call).
   Cross-sell: adds ONLY the shown item (qty 1), verifies the real cart on failure, never removes lines. */
(function () {
  if (window.SSPacksInit) return;
  window.SSPacksInit = true;

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  /* ---------- packs ---------- */
  function initPacks(root) {
    if (root.dataset.init) return; root.dataset.init = '1';
    var off = { 1: 0, 2: parseInt(root.dataset.off2, 10) || 0, 3: parseInt(root.dataset.off3, 10) || 0 };
    var variants = {};
    try { variants = JSON.parse(root.querySelector('[data-ss-packs-variants]').textContent); } catch (e) {}
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ss-pk'));
    var qty = root.querySelector('[data-ss-packs-qty]');
    var sum = root.querySelector('[data-ss-packs-sum]');
    var form = document.getElementById(root.dataset.form);
    var idIn = form && form.querySelector('input[name="id"]');
    var state = { n: 1 };

    function cur() { var id = idIn && idIn.value; return variants[id] || variants[Object.keys(variants)[0]] || { p: 0, m: 0, i: '' }; }

    function render() {
      var v = cur();
      cards.forEach(function (c) {
        var n = parseInt(c.dataset.n, 10);
        var unit = v.p - off[n];
        setText(c.querySelector('[data-ss-pk-total]'), money(unit * n));
        setText(c.querySelector('[data-ss-pk-was]'), money(v.p * n));
        var dis = n > v.m;
        if ((c.getAttribute('aria-disabled') === 'true') !== dis) { if (dis) c.setAttribute('aria-disabled', 'true'); else c.removeAttribute('aria-disabled'); }
        c.querySelectorAll('[data-ss-pk-img]').forEach(function (im) { if (v.i && im.getAttribute('src') !== v.i) im.setAttribute('src', v.i); });
      });
      if (state.n > v.m && v.m >= 1) select(1, false);
      var u = v.p - off[state.n];
      var t = state.n === 1 ? '1 × ' + money(v.p)
        : state.n + ' × ' + money(u) + ' each = ' + money(u * state.n) + ' · You save ' + money(off[state.n] * state.n);
      setText(sum, t);
      root.dataset.total = String(u * state.n);
      document.dispatchEvent(new CustomEvent('ss:pack', { detail: { n: state.n, total: u * state.n } }));
    }

    function select(n, focus) {
      var card = cards[n - 1];
      if (!card || card.getAttribute('aria-disabled') === 'true') return;
      state.n = n;
      cards.forEach(function (c, i) {
        var on = i === n - 1;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });
      if (qty.value !== String(n)) qty.value = String(n);
      if (focus) card.focus();
      render();
    }

    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { select(i + 1, false); });
      c.addEventListener('keydown', function (e) {
        var k = e.key, to = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') to = i + 1;
        if (k === 'ArrowLeft' || k === 'ArrowUp') to = i - 1;
        if (to === null) return;
        e.preventDefault();
        for (var s = 0; s < 3; s++) {
          to = (to + 3) % 3;
          if (cards[to].getAttribute('aria-disabled') !== 'true') { select(to + 1, true); return; }
          to += (k === 'ArrowRight' || k === 'ArrowDown') ? 1 : -1;
        }
      });
    });

    if (idIn) {
      idIn.addEventListener('change', render);
      new MutationObserver(render).observe(idIn, { attributes: true, attributeFilter: ['value'] });
    }
    var info = root.closest('product-info');
    if (info) new MutationObserver(function () { setTimeout(render, 30); }).observe(info, { childList: true, subtree: true });
    qty.value = '1';
    render();
    window.SSPacks = { get: function () { return { n: state.n, total: parseInt(root.dataset.total, 10) }; } };
  }

  /* ---------- cross-sell ---------- */
  function cartJS() { return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function qtyOf(cart, id) { var n = 0; (cart.items || []).forEach(function (i) { if (String(i.variant_id) === String(id)) n += i.quantity; }); return n; }

  function initXs(root) {
    if (root.dataset.init) return; root.dataset.init = '1';
    var btn = root.querySelector('[data-ss-xs-add]');
    if (!btn) return;
    var msg = root.querySelector('[data-ss-xs-msg]');
    function say(t, err) { setText(msg, t); msg.classList.toggle('is-error', !!err); }
    btn.addEventListener('click', function () {
      if (btn.dataset.busy || btn.disabled) return;
      var id = btn.dataset.variant;
      btn.dataset.busy = '1'; btn.disabled = true; btn.setAttribute('aria-busy', 'true');
      var label = btn.textContent; btn.textContent = 'Adding…'; say('');
      var before = null;
      cartJS().then(function (c) { before = c; }).catch(function () {}).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
        });
      }).then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
        .then(function (r) {
          if (r.ok && !r.d.status) {
            var drawer = document.querySelector('cart-drawer');
            say('Added to your cart.');
            if (drawer && r.d.sections && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(r.d); }
            else window.location.href = '/cart';
            return;
          }
          return verify((r.d && (r.d.description || r.d.message)) || 'It could not be added.');
        })
        .catch(function () { return verify('Connection problem.'); })
        .then(function () { delete btn.dataset.busy; btn.removeAttribute('aria-busy'); btn.disabled = false; btn.textContent = label; });

      function verify(reason) {
        return cartJS().then(function (after) {
          var d = before ? qtyOf(after, id) - qtyOf(before, id) : null;
          if (d === 1) say('Added to your cart.');
          else if (d === 0) say(reason + ' Nothing was added, and your cart was not changed.', true);
          else say(reason + ' Please check your cart before trying again.', true);
        }).catch(function () { say(reason + ' We could not confirm your cart. Please open the cart before trying again.', true); });
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ss-packs]').forEach(initPacks);
    document.querySelectorAll('[data-ss-xs]').forEach(initXs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
